import { render } from "./share-post.vue?vue&type=template&id=73fbc8b8&scoped=true"
import script from "./share-post.vue?vue&type=script&lang=js"
export * from "./share-post.vue?vue&type=script&lang=js"

import "./share-post.vue?vue&type=style&index=0&id=73fbc8b8&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fbc8b8"]])

export default __exports__